import { useEffect, useState } from 'react'

import { probeImageHttpStatus } from '../lib/probeImageHttpStatus'

/** 仅在 broken 为 true 时对 url 探测一次 HTTP 状态（跨域/CORS 失败则无状态码）。 */
export function useBrokenImageHttpStatus(url: string | undefined, broken: boolean): number | undefined {
  const [httpStatus, setHttpStatus] = useState<number | undefined>(undefined)

  useEffect(() => {
    if (!broken || !url?.trim()) {
      setHttpStatus(undefined)
      return
    }
    let cancelled = false
    void probeImageHttpStatus(url).then((s) => {
      if (!cancelled) setHttpStatus(s)
    })
    return () => {
      cancelled = true
    }
  }, [url, broken])

  return httpStatus
}
